import React from "react";
import { PrimaryText, SecondaryText } from "../../styles/global";
import LinkIcon from "@mui/icons-material/Link";
const CertificateList = [
  {
    name: "Python Programming",
    source: "Udemy",
    link: "https://drive.google.com/drive/folders/10uTSnTjvzfFcJjvUuu3eW3ukofV80tLO?usp=sharing",
  },
  {
    name: "Machine Learning",
    source: "Simplilearn",
    link: "https://simpli-web.app.link/e/aEqgyJpiIrb",
  },
  {
    name: "Data Science with R Programming",
    source: "Simplilearn",
    link: "https://simpli-web.app.link/e/F6ePXwmcGHb",
  },
  {
    name: "Tableau Training",
    source: "Simplilearn",
    link: "https://simpli-web.app.link/e/IN7Z1EqcGHb",
  },
  {
    name: "Data Pipeline (ETL) in Python",
    source: "Datacamp",
    link: "https://www.datacamp.com/statement-of-accomplishment/course/34a93299b22b0bcbd161e31150826914e4943449?raw=1",
  },
  {
    name: "Data Warehousing",
    source: "Datacamp",
    link: "https://www.datacamp.com/statement-of-accomplishment/course/93296d8e56f789d07b767c7ae63787741aed503b?raw=1",
  },
  {
    name: "MLOps",
    source: "Datacamp",
    link: "https://www.datacamp.com/statement-of-accomplishment/course/bdef06b75e57819fb57b4eefe523ccf6a3461a24?raw=1",
  },
  {
    name: "Alteryx",
    source: "Datacamp",
    link: "https://www.datacamp.com/statement-of-accomplishment/course/d6318260583290f4e4e04925dc8fd976a6f2fb66?raw=1",
  },
  {
    name: "Cloud Computing",
    source: "Datacamp",
    link: "https://www.datacamp.com/statement-of-accomplishment/course/a1061497d802eed2c925e555b76ddb60c9e0d6e1?raw=1",
  },
  {
    name: "Data Visualization with ggplot2",
    source: "Datacamp",
    link: "https://www.datacamp.com/statement-of-accomplishment/course/09b1e63082eac86687d539eb58824096131db9b5?raw=1",
  },
  {
    name: "JavaScript Programming",
    source: "Udemy",
    link: "https://drive.google.com/drive/folders/1JrG7qIkvRa9uwx7iNBg7_PMCreZOFksO?usp=sharing",
  },
];

const Certifications = () => {
  return (
    <div className="grid grid-cols-1  items-center gap-8">
      {CertificateList.map((item, i) => {
        const { name, source, link } = item;
        return (
          <div
            key={i}
            className="flex flex-col p-4 card-shadow border rounded-md"
          >
            <div className="flex justify-between">
              <PrimaryText className="text-center ">{name}</PrimaryText>

              <a href={link} target="_blank" rel="noreferrer">
                <LinkIcon className="text-white hover:text-[#ff5757]" />
              </a>
            </div>

            <SecondaryText className="mt-4">Source: {source}</SecondaryText>
          </div>
        );
      })}
    </div>
  );
};

export default Certifications;
